export function getMotion(_ref) {
  var prefixCls = _ref.prefixCls,
    motion = _ref.motion,
    animation = _ref.animation,
    transitionName = _ref.transitionName;
  if (motion) {
    return motion;
  }
  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }
  if (transitionName) {
    return {
      motionName: transitionName
    };
  }
  return null;
}